import React, { useRef } from "react";
import Button from "../../common/Button/Button";
import footerBg from "../../images/footer-bg.png";
import mobileFooterBg from "../../images/mobile/footer.png";

import { ReactComponent as LogoIcon } from "../../images/logo-big.svg";

import emailjs from "@emailjs/browser";
import config from "../../config.json";
import { ReactComponent as FacebookIcon } from "../../images/social-icons/facebook-purple-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/social-icons/twitter-purple-icon.svg";
import discordIcon from "../../images/social-icons/discord-purple.png";
import telegramIcon from "../../images/social-icons/telegram-purple.png";
import './footer.css';

function Footer({ isMobile }) {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_q94eo1d",
        "template_mkgd69o",
        form.current,
        "vl1UIBO6h6cEEAXfS"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <footer
      id="footer"
      className={`relative flex justify-between items-center flex-col`}
      style={{ minHeight: 370 }}
    >
      <img
        src={isMobile ? mobileFooterBg : footerBg}
        alt="orange-bg "
        className="w-full absolute flex center footer-image"
        style={{ zIndex: 0, width: "100%" }}
      />
      <div className="w-full relative" style={{marginTop: isMobile ? 100 : 280}}>
      <div className="wrapper footer-wrapper flex items-start lg:justify-between	" style={{ background: isMobile ? 'inherit' :'#FFC91A' }}>
        <div className="flex flex-col-reverse lg:flex-row justify-between w-full">
          <div className="flex lg:flex-col lg:items-center justify-center links-wrapper">
            <div className="lg:mb-2 lg:mr-4 lg:mr-0 flex justify-center">
              <a href="/" className="inline-block" aria-label="Cruip">
                  <LogoIcon className="footer-icon"/>
              </a>
            </div>
            <div className="flex items-center">
              <FacebookIcon className="footer-social-icon" />
              <img src={discordIcon} className="footer-social-icon" alt="discord" />
              <TwitterIcon className="footer-social-icon" />
              <img src={telegramIcon} className="footer-social-icon telegram-footer-icon " alt="discord" />
            </div>
          </div>
          {config["footer-columns"].map((item, index) => (
            <div
              className="ml-10"
              key={index}
            >
              <h6 className="footer-title mb-2">
                {item.title}
              </h6>
              <ul className="text-sm">
                {item.links.map((linkItem) => (
                  <li className="mb-2">
                    <a
                      href={linkItem.link}
                      className="footer-link hover:text-gray-900 transition duration-150 ease-in-out"
                    >
                      {linkItem.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div
          className="subscribe-wrapper"
          style={{ maxWidth: 570 }}
        >
          <h6 className="footer-text whitespace-nowrap">
            Subscribe to our newsletters!
          </h6>
          <form ref={form} onSubmit={sendEmail}>
            <div className="flex flex-wrap mb-4">
              <div className="w-full">
                <label className="block text-sm sr-only" htmlFor="newsletter">
                  Email
                </label>
                <div className="relative flex flex-col lg:flex-row items-end lg:items-center max-w-xs">
                  <input
                    id="newsletter"
                    type="email"
                    name="message"
                    className=" form-input input-full-width"
                    placeholder="Enter your email here"
                    required
                  />
                  <Button
                    text="Subscribe"
                    className="ml-2"
                    outlined
                    type="submit"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      </div>
      <div className="w-full flex py-4 lg:py-8 lg:w-10/12	justify-center relative reserved-wrapper">
        <p
          className="reserved-text"
        >
          All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
